import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  mainContainer: {
    flex: 1
  }
}))
